module.exports = __webpack_public_path__ + "survey.d49419a9.png";